export interface PostSuccess {
  success: boolean;
  error?: string;
}

export interface PubsubConfig {
  topic: string;
  project: string;
  apiKey: string;
  attributes: string[];
}

interface PubSubMessage {
  data: string;
  attributes: Record<string, string>;
}

let pubsubConfig: PubsubConfig = {
  topic: 'NOT_SET',
  project: 'NOT_SET',
  apiKey: 'NOT_SET',
  attributes: [],
};

const makeAttributes = <PayloadType extends Record<string, string>>(
  payload: PayloadType,
  attributes: string[]
): Record<string, string> => {
  const result: Record<string, string> = {};
  attributes.forEach((attr) => {
    if (attr in payload) {
      result[attr] = payload[attr];
    }
  });
  return result;
};

const generateMessages = <PayloadType extends Record<string, string>>(
  payloads: PayloadType[],
  attributes: string[]
): PubSubMessage[] =>
  payloads.map((payload: PayloadType) => ({
    data: globalThis.btoa(JSON.stringify(payload)),
    attributes: makeAttributes<PayloadType>(payload, attributes),
  }));

const postMessages = async <PayloadType extends Record<string, string>>(
  payloads: PayloadType[]
): Promise<PostSuccess> => {
  const key = pubsubConfig.apiKey;
  const url = `https://pubsub.googleapis.com/v1/projects/${pubsubConfig.project}/topics/${pubsubConfig.topic}:publish?key=${key}`;

  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      messages: generateMessages<PayloadType>(payloads, pubsubConfig.attributes),
    }),
  });
  (await response.json()) as { messageIds: string[]; error?: { message: string } };
  return {
    success: true,
  };
};

const PubsubService = {
  init: async (config: PubsubConfig): Promise<void> => {
    pubsubConfig = {
      topic: config.topic,
      project: config.project,
      apiKey: config.apiKey,
      attributes: config.attributes ?? [],
    };
  },
  publishToTopic: async <PayloadType extends Record<string, string>>(
    payload: PayloadType | PayloadType[]
  ): Promise<PostSuccess> => postMessages<PayloadType>(Array.isArray(payload) ? payload : [payload]),
};

export default PubsubService;
